/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_TranslationInputs */



/**
* | output |
* | --- |
* | "Machine Translation**" |
*
* @param {Signup_Compare_TranslationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_translation = /** @type {((inputs?: Signup_Compare_TranslationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_TranslationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Machine Translation**")
	if (locale === "de") return /** @type {LocalizedString} */ ("Machine Translation**")
	if (locale === "it") return /** @type {LocalizedString} */ ("Machine Translation**")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Machine Translation**")
	if (locale === "es") return /** @type {LocalizedString} */ ("Machine Translation**")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Machine Translation**")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Machine Translation**")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Machine Translation**")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Machine Translation**")
	return /** @type {LocalizedString} */ ("Machine Translation**")
});